// muiTheme.js — ponte entre os tokens CSS (src/style/theme.css) e o MUI.
// Lê as CSS custom properties de :root em runtime e monta o tema do MUI,
// para que editar theme.css reskine também os componentes MUI (após reload).
// Contrato: os nomes de token aqui DEVEM existir em theme.css.
import { createTheme } from '@mui/material/styles';

const cssVar = (name, fallback) => {
  if (typeof window === 'undefined' || !window.getComputedStyle) return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
};

const px = (name, fallback) => parseInt(cssVar(name, String(fallback)), 10) || fallback;

const muiTheme = createTheme({
  palette: {
    primary:   { main: cssVar('--primary', '#0d6efd') },
    secondary: { main: cssVar('--brand', '#1e3c72') },
    success:   { main: cssVar('--success', '#198754') },
    error:     { main: cssVar('--danger', '#dc3545') },
    warning:   { main: cssVar('--warning', '#ffc107') },
    info:      { main: cssVar('--info', '#17a2b8') },
    background: {
      default: cssVar('--page-bg', '#f0f1f3'),
      paper:   cssVar('--surface', '#ffffff'),
    },
    text: {
      primary:   cssVar('--text', '#212529'),
      secondary: cssVar('--text-muted', '#6c757d'),
    },
    divider: cssVar('--border', '#dee2e6'),
  },
  shape: {
    borderRadius: px('--radius', 10),
  },
  typography: {
    fontFamily: cssVar('--font-sans', 'system-ui, sans-serif'),
    fontSize: px('--fs-base', 15),
  },
});

export default muiTheme;
